import createApiServices from "./createApiServices";
import { extendUrlFactory } from '../../views/helpers/extenent-url'
// import queryString from 'query-string'

const prefixURL = `${extendUrlFactory.url}/api` || 'https://fulfillment-staging.merchize.com/api'

const api = createApiServices({ baseUrl: prefixURL})

export const getListIssues = (data) => {
    return api.makeAuthRequest({
        url: `/supplier/issues/search`,
        method: 'POST',
        data,
    })
}

export const getListJob = async (payload) => {
    const data = await api.makeAuthRequest({
        url: `/exporter/export-job/search`,
        method: 'POST',
        data: payload,
    })

    return data
}

export const getJobDetail = async (jobId) => {
    const data = await  api.makeAuthRequest({
        url: `/exporter/export-job/detail/${jobId}`,
        method: 'GET',
    })

    return data
}

export const retryJob = async (jobId) => {
    const data = await api.makeAuthRequest({
        url: `/exporter/export-job/retry/${jobId}`,
        method: 'GET',
    })

    return data
}

export const cancelJob = async (jobId) => {
    const data = await api.makeAuthRequest({
        url: `/exporter/export-job/cancel/${jobId}`,
        method: 'DELETE',
    })

    return data
}